import { Button } from "@/ui/Button";
import Icon from "@/ui/Icon";
import { RoundedButton } from "@/ui/RoundedButton";
import UserInfoBar from "./UserInfoBar";
import { useAuthentication } from "@thrivecoin/authentication-v2";
import { X_URL } from "@/lib/constants";
import { useShowCurrentUser } from "@/services/api/grants";
import { HeaderUserAreaProps } from "./types";
import { cn } from "@/lib/utils";

const HeaderUserArea = ({ className }: HeaderUserAreaProps) => {
  const { loginModal, user, logout } = useAuthentication();
  const { data: currentUser, isLoading } = useShowCurrentUser();
  if (user) {
    return (
      <div className={className}>
        <UserInfoBar user={user} currentUser={currentUser} isLoading={isLoading} logout={logout} />
      </div>
    );
  }

  return (
    <div className={cn("flex flex-col items-center gap-3 text-white lg:flex-row lg:items-start", className)}>
      <div className="flex items-center gap-3">
        <RoundedButton href={X_URL} target="_blank" aria-label="Follow us on X (Twitter)">
          <Icon name="twitter" />
        </RoundedButton>
      </div>
      <div className="mt-2 w-full max-w-[260px] lg:mt-0 lg:w-auto lg:max-w-none">
        <Button onClick={loginModal} className="w-full lg:w-auto">
          Sign Up / Sign In
        </Button>
      </div>
    </div>
  );
};

export default HeaderUserArea;
